module.exports = __webpack_public_path__ + "img/footer_icon_youtube.c4a3d6ed.svg";